import { render, staticRenderFns } from "./chooseDataAndCustomer.vue?vue&type=template&id=3c65f4d0&scoped=true"
import script from "./chooseDataAndCustomer.vue?vue&type=script&lang=js"
export * from "./chooseDataAndCustomer.vue?vue&type=script&lang=js"
import style0 from "./chooseDataAndCustomer.vue?vue&type=style&index=0&id=3c65f4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c65f4d0",
  null
  
)

export default component.exports